import { render, staticRenderFns } from "./CardGroupConfigList.vue?vue&type=template&id=d8bd8544&scoped=true&"
import script from "./CardGroupConfigList.vue?vue&type=script&lang=js&"
export * from "./CardGroupConfigList.vue?vue&type=script&lang=js&"
import style0 from "./CardGroupConfigList.vue?vue&type=style&index=0&id=d8bd8544&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8bd8544",
  null
  
)

export default component.exports